export default __webpack_public_path__ + "static/media/Intro-video-precog.f8bf0dbb.webm";